<template>
  <div class="container-list">
    <div class="common-page common-head">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="flex">
      <div class="flex1">
        <div class="common-page common-tool-bar">
          <div></div>
        </div>
        <div class="common-page common-list">
          <el-table :data="list" class="">
            <el-table-column prop="nowtime" align="center" label="报警时间"> </el-table-column>
            <el-table-column prop="evenClass" align="center" label="报警类型"> </el-table-column>
            <el-table-column prop="msgDescribe" align="center" label="报警地点"></el-table-column>
            <el-table-column prop="detailAddr" align="center" label="节点"> </el-table-column>
            <el-table-column prop="deviceType" align="center" label="设备类型"> </el-table-column>
          </el-table>
        </div>

        <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="canclesub" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { getrecord } from "../../api/device";
// import { getMapByid } from "../../api/common";
export default {
  props: ['c_num'],
  data() {
    return {
      list: [],
      params: {
        page: 1,

        c_company_num: this.c_num,
      },
      total: 0,

      showDia: false,
      searchForm: this.$getForm('checkRecordSearch'),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  components: {},
  methods: {
    // changeStatus(id,status){
    //     switchCompany({id,status}).then(res=>{
    //         this.getList()
    //     }).catch(err=>{

    //     })
    // },

    //导出

    canclesub() {
      this.showDia = false;
      this.params = {
        page: 1,
        aftertime: '',
        beforetime: '',
        c_name: '',
      };
      this.getList();
    },
    getList() {
      this.c_company_num = this.c_num;
      this.$post('/user/allcompanybaojing', this.params)
        .then((res) => {
          // console.log(res.data)x
          this.total = res.count;
          this.list = res.alllist;

          // console.log(this.list)
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          // var data = {...data,beforetime:data.startdate+' '+data.starttime,aftertime:data.enddate+' '+data.endtime}
          // console.log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          // console.log(data)
          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    getUnit() {},
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.btn {
  margin-left: 10px;
}
.common-head {
  border: none;
}
.common-page {
  padding: 0;
}
</style>
